export default "__VITE_ASSET__B40v5l4Y__"